// Checkout.js — Rota /checkout.
// Redesenhado para a página única "Finalizando a Compra" (Fluxo de Compra do Figma),
// reaproveitando a integração de pagamento Pagar.me existente.
// O antigo wizard (DadosIniciais → RevisarPedido → PagamentoPagarme) foi substituído
// por FinalizarCompra; os componentes legados permanecem no repositório para referência.
import React from "react";
import FinalizarCompra from "./finalizar/FinalizarCompra";

const Checkout = () => <FinalizarCompra />;

export default Checkout;
